import { render } from "./LoginPage.vue?vue&type=template&id=446e232c&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=446e232c&lang=scss"

import exportComponent from "/Users/janwever/Documents/github/ww-team-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__